module.exports = __webpack_public_path__ + "img/sylog.46981bfb.png";